var map = {
	"./_menu_accounting.svg": 3803,
	"./_menu_charging.svg": 323,
	"./_menu_settings.svg": 2696,
	"./arrow-left-s-line.svg": 953,
	"./arrow-right-circle.svg": 7453,
	"./arrow-right-line.svg": 8951,
	"./arrow-right-s-line.svg": 1067,
	"./battery.svg": 4513,
	"./building-line.svg": 7640,
	"./calendar.svg": 1421,
	"./charging.svg": 6193,
	"./clock.svg": 9212,
	"./close-line.svg": 9660,
	"./contacts-line.svg": 761,
	"./dashboard-line.svg": 4266,
	"./delete-bin-7-line.svg": 6445,
	"./download-2-line.svg": 8595,
	"./file-copy-line.svg": 9851,
	"./flash.svg": 9669,
	"./info.svg": 9932,
	"./information-line.svg": 9071,
	"./line-chart-line.svg": 4855,
	"./logout.svg": 230,
	"./mail-send-line.svg": 7870,
	"./money-euro-circle-line.svg": 9715,
	"./money.svg": 8835,
	"./pencil-line.svg": 4655,
	"./search-line.svg": 6650,
	"./settings-2-line.svg": 1613,
	"./settings-4-line.svg": 7348,
	"./timer.svg": 4819,
	"./user-3-line.svg": 2871,
	"./user-shared-line.svg": 7472,
	"./wallet-line.svg": 2885,
	"./warning.svg": 5561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2420;